(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bellace-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bellace-accordion')) {
    // Smooth open/close for native <details>. Without JavaScript the details still work.
    class BellaceAccordion extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('details.bellace-accordion__item'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.items.forEach((item) => {
          item.querySelector('summary').addEventListener('click', (event) => {
            event.preventDefault();
            if (item.open && !item.classList.contains('is-collapsed')) {
              this.collapse(item);
            } else {
              this.expand(item);
            }
          });
        });
        this.onBlockSelect = (event) => {
          const item = event.target.closest('details');
          if (item && this.contains(item)) this.expand(item);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      expand(item) {
        if (this.hasAttribute('data-one-open')) {
          this.items.forEach((other) => {
            if (other !== item && other.open) this.collapse(other);
          });
        }
        clearTimeout(item.bellaceTimer);
        if (this.reducedMotion.matches) {
          item.classList.remove('is-collapsed');
          item.open = true;
          return;
        }
        if (!item.open) {
          // Start from the collapsed state instantly, not by animating into it.
          item.classList.add('is-instant', 'is-collapsed');
          item.open = true;
          item.querySelector('.bellace-accordion__panel').offsetHeight;
          item.classList.remove('is-instant');
        }
        // Wait until the opened content has rendered once in its collapsed state, then animate open.
        requestAnimationFrame(() => requestAnimationFrame(() => item.classList.remove('is-collapsed')));
      }

      collapse(item) {
        clearTimeout(item.bellaceTimer);
        if (this.reducedMotion.matches) {
          item.open = false;
          return;
        }
        item.classList.add('is-collapsed');
        const duration = parseFloat(getComputedStyle(item.querySelector('.bellace-accordion__panel')).transitionDuration) * 1000 || 0;
        item.bellaceTimer = setTimeout(() => {
          if (!item.classList.contains('is-collapsed')) return;
          item.open = false;
          item.classList.remove('is-collapsed');
        }, duration + 50);
      }
    }

    customElements.define('bellace-accordion', BellaceAccordion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellace-buy-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bellace-buy-card')) {
    class BellaceBuyCard extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.button = this.querySelector('[data-buy-card-submit]');
        this.label = this.querySelector('[data-buy-card-label]');
        this.price = this.querySelector('[data-buy-card-price]');
        this.selects = Array.from(this.querySelectorAll('select[data-option-index]'));
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.mainPast = false;
        this.footerVisible = false;
        this.update = this.update.bind(this);

        this.button.addEventListener('click', () => {
          const main = this.mainButton();
          if (main && !main.disabled) main.click();
        });

        this.selects.forEach((select) => {
          select.addEventListener('change', () => this.choose(Number(select.dataset.optionIndex), select.value));
        });

        this.footerObserver = new IntersectionObserver((entries) => {
          this.footerVisible = entries.some((entry) => entry.isIntersecting);
          this.update();
        });
        const footer =
          document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer.footer');
        if (footer) this.footerObserver.observe(footer);

        // The cookie banner is injected into <body>; re-check when it comes or goes.
        this.bodyObserver = new MutationObserver(this.update);
        this.bodyObserver.observe(document.body, { childList: true });

        window.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update, { passive: true });
        this.desktop.addEventListener('change', this.update);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.sectionId) return;
            this.restoreScroll?.();
            this.watchMain();
            this.syncOptions();
            this.sync();
          });
        }

        this.watchMain();
        this.syncOptions();
        this.update();
      }

      disconnectedCallback() {
        this.footerObserver?.disconnect();
        this.bodyObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.unsubscribe?.();
        window.removeEventListener('scroll', this.update);
        window.removeEventListener('resize', this.update);
      }

      mainButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      // One group per option in Dawn's picker: a fieldset of radios or a select.
      optionGroups() {
        const picker = document.getElementById(`variant-selects-${this.sectionId}`);
        if (!picker) return [];
        return Array.from(picker.querySelectorAll('fieldset, .product-form__input--dropdown'));
      }

      // After a variant change Dawn scrolls the page back up (to the new photo, and by
      // focusing the option it updated). When the change comes from this card the
      // shopper is buying from here, so the card keeps their place and its focus.
      holdScroll() {
        if (this.holding) return;
        const original = window.scrollTo;
        const savedY = window.scrollY;
        const focused = this.contains(document.activeElement) ? document.activeElement : null;
        this.holding = true;
        window.scrollTo = () => {};
        const restore = () => {
          if (!this.holding) return;
          clearTimeout(this.restoreTimer);
          window.scrollTo = original;
          window.scrollTo({ top: savedY, behavior: 'instant' });
          focused?.focus({ preventScroll: true });
          this.holding = false;
          this.update();
        };
        this.restoreScroll = () => setTimeout(restore, 80);
        this.restoreTimer = setTimeout(restore, 6000);
      }

      choose(index, value) {
        const group = this.optionGroups()[index];
        if (!group) return;
        this.holdScroll();
        const select = group.querySelector('select');
        if (select) {
          const option = Array.from(select.options).find((item) => item.value === value || item.textContent.trim() === value);
          if (!option || option.selected) return;
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        const input = Array.from(group.querySelectorAll('input[type="radio"]')).find((item) => item.value === value);
        if (input && !input.checked) input.click();
      }

      // Mirror the main picker: the chosen value per option, and which values are sold out.
      syncOptions() {
        const groups = this.optionGroups();
        const soldOut = this.dataset.soldOut || '';
        this.selects.forEach((select) => {
          const group = groups[Number(select.dataset.optionIndex)];
          if (!group) return;
          const mainSelect = group.querySelector('select');
          let chosen = null;
          const unavailable = new Set();
          if (mainSelect) {
            const option = mainSelect.options[mainSelect.selectedIndex];
            chosen = option ? option.value : null;
            Array.from(mainSelect.options).forEach((item) => {
              if (item.classList.contains('disabled') || item.dataset.optionAvailable === 'false') unavailable.add(item.value);
            });
          } else {
            group.querySelectorAll('input[type="radio"]').forEach((input) => {
              if (input.checked) chosen = input.value;
              if (input.classList.contains('disabled')) unavailable.add(input.value);
            });
          }
          Array.from(select.options).forEach((item) => {
            const base = item.dataset.base || item.textContent.trim();
            item.dataset.base = base;
            item.textContent = unavailable.has(item.value) && soldOut ? `${base} – ${soldOut}` : base;
          });
          if (chosen !== null) select.value = chosen;
        });
      }

      watchMain() {
        const main = this.mainButton();
        if (!main || main === this.observedMain) return;
        this.observedMain = main;
        this.buttonObserver?.disconnect();
        this.buttonObserver = new MutationObserver(() => this.sync());
        this.buttonObserver.observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
        this.sync();
      }

      // Same label, price and state as the main button.
      sync() {
        const main = this.mainButton();
        if (!main) return;
        this.button.disabled = main.disabled;
        const text = main.querySelector('span')?.textContent.trim();
        if (text) this.label.textContent = text;
        const price = main.querySelector('[data-bellace-atc-price]')?.textContent.trim();
        if (price) this.price.textContent = price;
      }

      cookieBannerVisible() {
        const banner = document.getElementById('shopify-pc__banner');
        if (!banner) return false;
        const style = getComputedStyle(banner);
        return style.display !== 'none' && style.visibility !== 'hidden' && banner.getBoundingClientRect().height > 0;
      }

      update() {
        if (this.holding) return;
        const main = this.mainButton();
        // Past = the main button has scrolled up out of view. Read directly: a fast
        // scroll can jump past it without an observer ever firing.
        this.mainPast = main ? main.getBoundingClientRect().bottom < 0 : false;
        const show = this.desktop.matches && this.mainPast && !this.footerVisible && !this.cookieBannerVisible();
        if (show === this.classList.contains('is-visible')) return;
        // Hiding because the main button is back in view: keep keyboard focus there.
        if (!show && main && !this.mainPast && this.contains(document.activeElement)) main.focus({ preventScroll: true });
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
      }
    }

    customElements.define('bellace-buy-card', BellaceBuyCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellace-carousel-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bellace-carousel')) {
    class BellaceCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.prev = this.querySelector('[data-carousel-prev]');
        this.next = this.querySelector('[data-carousel-next]');
        if (!this.track) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.update = this.update.bind(this);
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.update();
            this.ticking = false;
          });
        };

        this.prev?.addEventListener('click', () => this.go(-1));
        this.next?.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      step() {
        const slide = this.track.querySelector('[data-carousel-slide]');
        if (!slide) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      go(direction) {
        this.track.scrollBy({
          left: direction * this.step(),
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
        });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.classList.toggle('is-scrollable', max > 2);
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
      }
    }

    customElements.define('bellace-carousel', BellaceCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellace-cart-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.bellaceCartMotion) return;
    window.bellaceCartMotion = true;

    const seen = new Map(); // line key -> { quantity, price, newAt }
    const RISE_MS = 700;
    const totals = new Map(); // container id (drawer or cart page) -> total text
    let firstPass = true;

    const markNew = (line, delay = 0) => {
      if (delay) line.style.animationDelay = `${-delay}ms`;
      line.classList.add('is-new');
      line.addEventListener(
        'animationend',
        () => {
          line.classList.remove('is-new');
          line.style.animationDelay = '';
        },
        { once: true }
      );
    };

    const flash = (element) => {
      if (!element) return;
      element.classList.remove('is-updated');
      void element.offsetWidth; // restart the animation
      element.classList.add('is-updated');
    };

    const scan = () => {
      const lines = document.querySelectorAll('.bellace-cart-line[data-line-key]');
      const present = new Set();
      lines.forEach((line) => {
        const key = line.dataset.lineKey;
        const quantity = line.dataset.lineQuantity;
        const price = line.querySelector('[data-line-price]')?.textContent.trim();
        present.add(key);
        const before = seen.get(key);
        let newAt = before?.newAt ?? null;
        if (!before) {
          if (!firstPass) {
            newAt = performance.now();
            markNew(line);
          }
        } else {
          // Dawn re-renders the drawer twice after an add; keep a new line's rise going smoothly.
          const elapsed = newAt === null ? Infinity : performance.now() - newAt;
          if (elapsed < RISE_MS && !line.classList.contains('is-new')) markNew(line, Math.round(elapsed));
          if (before.quantity !== quantity) flash(line.querySelector('.quantity__input'));
          if (before.price !== price) flash(line.querySelector('[data-line-price]'));
        }
        seen.set(key, { quantity, price, newAt });
      });
      seen.forEach((_, key) => {
        if (!present.has(key)) seen.delete(key);
      });

      // The drawer and the cart page each have a total; track them separately.
      document.querySelectorAll('[data-cart-total]').forEach((element) => {
        const container = element.closest('#CartDrawer, #main-cart-footer')?.id || 'other';
        const text = element.textContent.trim();
        const before = totals.get(container);
        if (!firstPass && before !== undefined && before !== text) flash(element);
        totals.set(container, text);
      });
      firstPass = false;
    };

    let queued = false;
    const queueScan = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        scan();
      });
    };

    const start = () => {
      scan();
      const observer = new MutationObserver(queueScan);
      ['CartDrawer', 'main-cart-items', 'main-cart-footer'].forEach((id) => {
        const element = document.getElementById(id);
        if (element) observer.observe(element, { childList: true, subtree: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  // ---------------------------------------------------------------------------
  // Cart slots: upsell checkbox, "complete your set" add buttons, milestone bar.
  // Uses the normal /cart/add path and Dawn's own render methods; Dawn's cart
  // JavaScript itself is not changed.
  // ---------------------------------------------------------------------------
  (() => {
    if (window.bellaceCartSlots) return;
    window.bellaceCartSlots = true;

    const drawer = () => document.querySelector('cart-drawer');
    const onCartPage = () => !!document.getElementById('main-cart-items');

    const showError = (slot, message) => {
      const error = slot?.querySelector('.bellace-slot__error');
      if (!error) return;
      error.textContent = message || '';
      error.hidden = !message;
    };

    // Same request Dawn's product form makes, including the sections it re-renders.
    const addToCart = async (variantId, slot) => {
      const cart = drawer();
      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      if (cart && !onCartPage()) {
        body.append('sections', cart.getSectionsToRender().map((section) => section.id));
        body.append('sections_url', window.location.pathname);
      }
      const response = await fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body,
      });
      const data = await response.json();
      if (data.status) {
        showError(slot, data.description || data.message);
        return false;
      }
      showError(slot, '');
      if (cart && !onCartPage()) cart.renderContents(data);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bellace-slot', productVariantId: variantId, cartData: data });
      }
      return true;
    };

    // Unticking removes the line through its own Remove button, so Dawn handles it.
    const removeVariant = (variantId, slot) => {
      const scope = slot?.closest('#CartDrawer') || document.getElementById('main-cart-items') || document;
      const input = scope.querySelector(`.quantity__input[data-quantity-variant-id="${variantId}"]`);
      const remove = input?.closest('.cart-item')?.querySelector('cart-remove-button button');
      if (remove) remove.click();
      return !!remove;
    };

    // Capture phase + stopPropagation: the slots sit inside Dawn's cart-drawer-items, which
    // treats every change event as a quantity edit. Slot changes must never reach it.
    document.addEventListener(
      'change',
      (event) => {
        if (event.target.closest?.('[data-bellace-slot]')) {
          event.stopPropagation();
          handleSlotChange(event);
        }
      },
      true
    );

    const handleSlotChange = async (event) => {
      const checkbox = event.target.closest?.('[data-bellace-upsell]');
      if (checkbox) {
        const slot = checkbox.closest('[data-bellace-slot]');
        checkbox.disabled = true;
        const ok = checkbox.checked
          ? await addToCart(checkbox.dataset.variantId, slot).catch(() => false)
          : removeVariant(checkbox.dataset.variantId, slot);
        if (!ok) checkbox.checked = !checkbox.checked;
        checkbox.disabled = false;
        return;
      }
      const select = event.target.closest?.('.bellace-bundle__select');
      if (select) {
        const price = select.selectedOptions[0]?.dataset.price;
        const target = select.closest('form')?.querySelector('[data-bundle-price]');
        if (price && target) target.textContent = price;
      }
    };

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest?.('[data-bellace-add]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (button?.getAttribute('aria-busy') === 'true') return;
      button?.setAttribute('aria-busy', 'true');
      const variantId = new FormData(form).get('id');
      await addToCart(variantId, form.closest('[data-bellace-slot]')).catch(() => false);
      button?.removeAttribute('aria-busy');
    });

    // Cart page: Dawn only refreshes the subtotal there, so refresh the whole summary
    // (subtotal, slots, empty state) after every cart change.
    let refreshing = null;
    const refreshCartPageSummary = () => {
      const footer = document.getElementById('main-cart-footer');
      if (!footer?.dataset.id) return;
      refreshing?.abort();
      refreshing = new AbortController();
      fetch(`${routes.cart_url}?section_id=${footer.dataset.id}`, { signal: refreshing.signal })
        .then((response) => response.text())
        .then((text) => {
          const fresh = new DOMParser().parseFromString(text, 'text/html').getElementById('main-cart-footer');
          const current = document.getElementById('main-cart-footer');
          if (!fresh || !current) return;
          const focusedSlot = document.activeElement?.closest?.('[data-bellace-slot]')?.dataset.bellaceSlot;
          current.innerHTML = fresh.innerHTML;
          current.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
          if (focusedSlot) current.querySelector(`[data-bellace-slot="${focusedSlot}"] input, [data-bellace-slot="${focusedSlot}"] button`)?.focus();
        })
        .catch(() => {});
    };
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        if (onCartPage()) refreshCartPageSummary();
      });
    }

    // Milestone bar grows from its previous value after each re-render (transform only).
    const progress = new Map();
    const animateMilestones = () => {
      document.querySelectorAll('[data-milestone]').forEach((milestone) => {
        const fill = milestone.querySelector('.bellace-milestone__fill');
        if (!fill || fill.dataset.bellaceSeen) return;
        fill.dataset.bellaceSeen = 'true';
        const key = milestone.dataset.milestone + (milestone.closest('#CartDrawer') ? '-drawer' : '-page');
        const target = getComputedStyle(fill).getPropertyValue('--progress').trim();
        const before = progress.get(key);
        progress.set(key, target);
        if (before === undefined || before === target) return;
        fill.style.transition = 'none';
        fill.style.transform = `scaleX(${before})`;
        void fill.offsetWidth;
        fill.style.transition = '';
        fill.style.transform = '';
      });
    };
    new MutationObserver(() => requestAnimationFrame(animateMilestones)).observe(document.body, { childList: true, subtree: true });
    animateMilestones();

    // Theme editor: open the drawer while its section or a slot block is selected.
    if (window.Shopify?.designMode) {
      const isDrawer = (event) => event.target?.closest?.('.bellace-cart-drawer-section') || event.detail?.sectionId === 'cart-drawer';
      document.addEventListener('shopify:section:select', (event) => isDrawer(event) && drawer()?.open());
      document.addEventListener('shopify:block:select', (event) => isDrawer(event) && drawer()?.open());
      document.addEventListener('shopify:section:deselect', (event) => isDrawer(event) && drawer()?.close());
      document.addEventListener('shopify:section:load', (event) => {
        if (isDrawer(event)) setTimeout(() => drawer()?.open(), 50);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellace-compare"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bellace-compare')) {
    class BellaceCompare extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('[data-compare-frame]');
        this.handle = this.querySelector('[role="slider"]');
        this.template = this.handle.dataset.valueTemplate || '[value]';
        this.value = 50;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.frame.addEventListener('pointerdown', this.onPointerDown);
        this.handle.addEventListener('keydown', (event) => this.onKeydown(event));

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!this.reducedMotion.matches) {
          this.hintObserver = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) return;
              this.hintObserver.disconnect();
              this.hint();
            },
            { threshold: 0.6 }
          );
          this.hintObserver.observe(this);
        }
      }

      disconnectedCallback() {
        this.hintObserver?.disconnect();
      }

      set(value) {
        this.value = Math.round(Math.min(100, Math.max(0, value)));
        this.style.setProperty('--pos', this.value);
        this.handle.setAttribute('aria-valuenow', this.value);
        this.handle.setAttribute('aria-valuetext', this.template.replace('[value]', this.value));
      }

      fromPointer(event) {
        const rect = this.frame.getBoundingClientRect();
        return ((event.clientX - rect.left) / rect.width) * 100;
      }

      onPointerDown(event) {
        if (event.button !== 0) return;
        this.classList.remove('is-easing');
        this.dragging = true;
        this.classList.add('is-dragging');
        this.frame.setPointerCapture(event.pointerId);
        this.frame.addEventListener('pointermove', this.onPointerMove);
        this.frame.addEventListener('pointerup', this.onPointerUp);
        this.frame.addEventListener('pointercancel', this.onPointerUp);
        this.set(this.fromPointer(event));
        if (event.target !== this.handle) this.handle.focus({ preventScroll: true });
      }

      onPointerMove(event) {
        if (!this.dragging) return;
        this.pending = this.fromPointer(event);
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.set(this.pending);
          this.ticking = false;
        });
      }

      onPointerUp(event) {
        this.dragging = false;
        this.classList.remove('is-dragging');
        if (this.frame.hasPointerCapture(event.pointerId)) this.frame.releasePointerCapture(event.pointerId);
        this.frame.removeEventListener('pointermove', this.onPointerMove);
        this.frame.removeEventListener('pointerup', this.onPointerUp);
        this.frame.removeEventListener('pointercancel', this.onPointerUp);
      }

      onKeydown(event) {
        const steps = { ArrowLeft: -5, ArrowDown: -5, ArrowRight: 5, ArrowUp: 5, PageDown: -10, PageUp: 10 };
        let next = null;
        if (event.key in steps) next = this.value + steps[event.key];
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = 100;
        if (next === null) return;
        event.preventDefault();
        this.classList.remove('is-easing');
        this.set(next);
      }

      hint() {
        if (this.dragging) return;
        this.classList.add('is-easing');
        this.set(62);
        setTimeout(() => {
          if (this.dragging || !this.classList.contains('is-easing')) return;
          this.set(50);
          setTimeout(() => this.classList.remove('is-easing'), 800);
        }, 800);
      }
    }

    customElements.define('bellace-compare', BellaceCompare);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellace-facets"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.bellaceFacetPills) return;
    window.bellaceFacetPills = true;

    const openPills = () => document.querySelectorAll('.bellace-facets .bellace-pill[open]');
    const close = (details, focus) => {
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', 'false');
      if (focus) summary.focus();
    };

    // One card at a time; keep aria-expanded right after Dawn re-renders a summary.
    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.matches('.bellace-facets .bellace-pill')) return;
        details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open));
        if (details.open) openPills().forEach((other) => other !== details && close(other));
      },
      true
    );

    // A click outside closes the open card.
    document.addEventListener('click', (event) => {
      openPills().forEach((details) => {
        if (!details.contains(event.target)) close(details);
      });
    });

    // Esc closes the card and returns focus to its pill.
    document.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape') return;
      const details = event.target.closest && event.target.closest('.bellace-facets .bellace-pill[open]');
      if (details) close(details, true);
    });

    // Picking a sort order closes the sort card; filters stay open for more choices.
    document.addEventListener('change', (event) => {
      const details = event.target.closest && event.target.closest('.bellace-facets .bellace-pill--sort');
      if (!details) return;
      setTimeout(() => close(details, true), 150);

      // Dawn swaps the sort summary when results arrive; keep keyboard focus on the pill.
      const observer = new MutationObserver(() => {
        const summary = details.querySelector('summary');
        if (!summary || !summary.isConnected) return;
        if (document.activeElement === document.body || !document.activeElement) summary.focus();
        observer.disconnect();
      });
      observer.observe(details, { childList: true });
      setTimeout(() => observer.disconnect(), 5000);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellace-gallery-tint"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bellace-gallery-tint')) {
    class BellaceGalleryTint extends HTMLElement {
      connectedCallback() {
        this.index = Number(this.dataset.optionIndex);
        if (!(this.index >= 0)) return;
        this.value = this.dataset.value || '';
        this.tints = {};
        (this.dataset.tints || '').split(/\r?\n/).forEach((line) => {
          const at = line.indexOf(':');
          if (at < 1) return;
          const name = line.slice(0, at).trim().toLowerCase();
          const color = line.slice(at + 1).trim();
          if (name && color && CSS.supports('color', color)) this.tints[name] = color;
        });

        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.section || !event.data.variant) return;
          const value = String(event.data.variant.options[this.index] || '').trim().toLowerCase();
          if (value === this.value) return;
          this.value = value;
          this.show(this.tints[value]);
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      // Paint the hidden layer, then cross-fade to it.
      show(color) {
        const layers = Array.from(this.querySelectorAll('.bellace-tint__layer'));
        const active = layers.find((layer) => layer.classList.contains('is-active')) || layers[0];
        const next = layers.find((layer) => layer !== active);
        if (!next) return;
        if (color) {
          next.style.setProperty('--tint', color);
          next.classList.add('has-tint');
        } else {
          next.style.removeProperty('--tint');
          next.classList.remove('has-tint');
        }
        next.classList.add('is-active');
        active.classList.remove('is-active');
      }
    }

    customElements.define('bellace-gallery-tint', BellaceGalleryTint);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellace-pdp-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bellace-pdp-addons')) {
    // After the wig lands in the cart, add every ticked add-on in one request and
    // redraw the cart drawer with Dawn's own render method.
    class BellacePdpAddons extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form') this.addTicked();
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      async addTicked() {
        const ticked = [...this.querySelectorAll('[data-addon-variant]:checked')];
        if (!ticked.length || this.busy) return;
        this.busy = true;
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = {
          items: ticked.map((input) => ({ id: Number(input.dataset.addonVariant), quantity: 1 })),
        };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }
        try {
          const response = await fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await response.json();
          if (response.ok && cart && data.sections) cart.renderContents(data);
          ticked.forEach((input) => (input.checked = false));
        } catch (error) {
          console.error(error);
        } finally {
          this.busy = false;
        }
      }
    }

    customElements.define('bellace-pdp-addons', BellacePdpAddons);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellace-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.bellaceGridReveal) return;
    window.bellaceGridReveal = true;

    // Dawn's facets.js replaces the grid after filtering or sorting (collection
    // and search pages); bring the
    // new cards into the shared reveal (or simply show them without it).
    const watch = () => {
      const container = document.getElementById('ProductGridContainer');
      if (!container || container.dataset.bellaceWatched) return;
      container.dataset.bellaceWatched = 'true';
      new MutationObserver(() => {
        if (window.bellaceReveal) {
          window.bellaceReveal.setup(container);
        } else {
          container.querySelectorAll('.reveal').forEach((element) => element.classList.add('is-revealed'));
        }
      }).observe(container, { childList: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch);
    } else {
      watch();
    }
    document.addEventListener('shopify:section:load', watch);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellace-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bellace-drawer')) {
    class BellaceDrawer extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[role="dialog"]');
        this.onKeydown = this.onKeydown.bind(this);
        this.onClick = (event) => {
          if (event.target.closest('[data-drawer-close]')) this.close();
        };
        this.addEventListener('click', this.onClick);
      }

      open(trigger) {
        if (this.classList.contains('is-open')) return;
        this.trigger = trigger || null;
        this.trigger?.setAttribute('aria-expanded', 'true');

        // Lock page scroll without a jump where the scrollbar was.
        const scrollbar = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.paddingRight = scrollbar > 0 ? `${scrollbar}px` : '';
        document.body.classList.add('overflow-hidden');

        this.classList.add('is-open');
        document.addEventListener('keydown', this.onKeydown);
        const close = this.querySelector('.bellace-drawer__close');
        requestAnimationFrame(() => (close || this.panel).focus({ preventScroll: true }));
      }

      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        document.removeEventListener('keydown', this.onKeydown);
        document.body.classList.remove('overflow-hidden');
        document.body.style.paddingRight = '';
        if (this.trigger) {
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.focus({ preventScroll: true });
        }
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;

        // Keep focus inside the panel.
        const focusable = Array.from(
          this.panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])')
        ).filter((element) => element.offsetParent !== null);
        if (!focusable.length) {
          event.preventDefault();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || !this.panel.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('bellace-drawer', BellaceDrawer);

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-drawer-open]');
      if (!trigger) return;
      const drawer = document.getElementById(trigger.dataset.drawerOpen);
      if (drawer && typeof drawer.open === 'function') drawer.open(trigger);
    });

  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellace-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bellace-sticky-atc')) {
    class BellaceStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.button = this.querySelector('[data-sticky-submit]');
        this.label = this.querySelector('[data-sticky-label]');
        this.variantLabel = this.querySelector('[data-sticky-variant]');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.mainPast = false;
        this.footerVisible = false;

        this.update = this.update.bind(this);
        this.button.addEventListener('click', () => {
          const main = this.mainButton();
          if (main && !main.disabled) main.click();
        });

        this.footerObserver = new IntersectionObserver((entries) => {
          this.footerVisible = entries.some((entry) => entry.isIntersecting);
          this.update();
        });
        // The store footer section group (other <footer> elements exist inside drawers and cards).
        const footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer.footer');
        if (footer) this.footerObserver.observe(footer);

        this.mainObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          // Past = the main button has left the viewport by scrolling down.
          this.mainPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.update();
        });

        // The cookie banner is injected into <body> without a scroll; re-check when it appears or goes.
        this.bodyObserver = new MutationObserver(this.update);
        this.bodyObserver.observe(document.body, { childList: true });

        this.observeMain();
        this.mobile.addEventListener('change', this.update);
        window.addEventListener('scroll', this.update, { passive: true });

        // Dawn re-renders parts of the product on variant change; keep the bar in sync.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.sectionId) return;
            if (this.variantLabel && event.data.variant) this.variantLabel.textContent = event.data.variant.title;
            this.observeMain();
            this.sync();
          });
        }
      }

      disconnectedCallback() {
        this.footerObserver?.disconnect();
        this.mainObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.bodyObserver?.disconnect();
        this.unsubscribe?.();
        window.removeEventListener('scroll', this.update);
      }

      mainButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      observeMain() {
        const main = this.mainButton();
        if (!main || main === this.observedMain) return;
        this.observedMain = main;
        this.mainObserver.disconnect();
        this.mainObserver.observe(main);
        this.buttonObserver?.disconnect();
        this.buttonObserver = new MutationObserver(() => this.sync());
        this.buttonObserver.observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
        this.sync();
      }

      sync() {
        const main = this.mainButton();
        if (!main) return;
        this.button.disabled = main.disabled;
        const text = main.querySelector('span')?.textContent.trim();
        if (text) this.label.textContent = text;
      }

      cookieBannerVisible() {
        const banner = document.getElementById('shopify-pc__banner');
        if (!banner) return false;
        const style = getComputedStyle(banner);
        return style.display !== 'none' && style.visibility !== 'hidden' && banner.getBoundingClientRect().height > 0;
      }

      update() {
        // Read the position directly as well: a fast scroll can jump past the button
        // without it ever intersecting, in which case the observer does not fire.
        const main = this.mainButton();
        if (main) this.mainPast = main.getBoundingClientRect().bottom < 0;
        const show = this.mobile.matches && this.mainPast && !this.footerVisible && !this.cookieBannerVisible();
        if (show === this.classList.contains('is-visible')) return;
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
      }
    }

    customElements.define('bellace-sticky-atc', BellaceStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bellace-urgency"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bellace-urgency')) {
    // Times are worked out in New York time, where orders are processed.
    const ZONE = 'America/New_York';

    const zoned = (date) => {
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-US', {
          timeZone: ZONE,
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hourCycle: 'h23',
        })
          .formatToParts(date)
          .map((part) => [part.type, part.value])
      );
      return new Date(+parts.year, parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
    };

    const isWeekend = (date) => date.getDay() === 0 || date.getDay() === 6;

    const addBusinessDays = (date, days) => {
      const result = new Date(date);
      let left = days;
      while (left > 0) {
        result.setDate(result.getDate() + 1);
        if (!isWeekend(result)) left -= 1;
      }
      return result;
    };

    const pad = (value) => String(value).padStart(2, '0');

    class BellaceUrgency extends HTMLElement {
      connectedCallback() {
        this.setupDemoStock();
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        clearTimeout(this.demoTimer);
      }

      // Concept walkthroughs only: never runs on the published theme.
      setupDemoStock() {
        const row = this.querySelector('[data-demo-stock]');
        if (!row || window.Shopify?.theme?.role === 'main') return;
        const min = Math.max(1, Number(row.dataset.min) || 3);
        const max = Math.max(min, Number(row.dataset.max) || 9);
        const key = `bellace-demo-stock-${row.dataset.key}`;
        const text = row.querySelector('[data-demo-text]');
        const random = () => min + Math.floor(Math.random() * (max - min + 1));
        let count;
        try {
          count = Number(sessionStorage.getItem(key)) || random();
        } catch (error) {
          count = random();
        }
        const show = () => {
          try {
            sessionStorage.setItem(key, count);
          } catch (error) {}
          this.fill(text, { count: String(count) });
          row.hidden = false;
        };
        // Every 40 to 80 seconds one "sells"; at the minimum it starts over within the range.
        const step = () => {
          count = count > min ? count - 1 : random();
          show();
          this.demoTimer = setTimeout(step, 40000 + Math.random() * 40000);
        };
        show();
        this.demoTimer = setTimeout(step, 40000 + Math.random() * 40000);
      }

      tick() {
        const now = zoned(new Date());
        const cutoffHour = Number(this.dataset.cutoff) || 14;

        // The next moment an order still ships the same business day.
        const shipDay = new Date(now);
        shipDay.setHours(cutoffHour, 0, 0, 0);
        if (isWeekend(shipDay) || now >= shipDay) {
          do {
            shipDay.setDate(shipDay.getDate() + 1);
          } while (isWeekend(shipDay));
        }
        const shipDate = addBusinessDays(shipDay, Number(this.dataset.processing) || 0);

        this.renderShip(now, shipDay, shipDate);
        this.renderArrive(shipDate);
        this.renderSale();
      }

      renderShip(now, cutoff, shipDate) {
        const text = this.querySelector('[data-ship-text]');
        if (!text) return;
        const left = Math.max(0, cutoff - now);
        const hours = Math.floor(left / 3600000);
        const minutes = Math.floor((left % 3600000) / 60000);
        const seconds = Math.floor((left % 60000) / 1000);
        // data-clock="digital" shows a ticking hh:mm:ss clock (cart banner).
        const time =
          this.dataset.clock === 'digital'
            ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
            : hours > 0
              ? `${hours}h ${pad(minutes)}m`
              : `${minutes}m ${pad(seconds)}s`;

        const today = new Date(now);
        today.setHours(0, 0, 0, 0);
        const ship = new Date(shipDate);
        ship.setHours(0, 0, 0, 0);
        const diff = Math.round((ship - today) / 86400000);
        let day;
        if (diff === 0) day = this.dataset.today;
        else if (diff === 1) day = this.dataset.tomorrow;
        else day = ship.toLocaleDateString('en-US', { weekday: 'long' });

        this.fill(text, { time, day });
        text.closest('[data-ship-row]').hidden = false;
      }

      renderArrive(shipDate) {
        const text = this.querySelector('[data-arrive-text]');
        if (!text) return;
        const format = { weekday: 'short', month: 'short', day: 'numeric' };
        const from = addBusinessDays(shipDate, Number(this.dataset.min) || 3).toLocaleDateString('en-US', format);
        const to = addBusinessDays(shipDate, Number(this.dataset.max) || 7).toLocaleDateString('en-US', format);
        this.fill(text, { from, to });
        text.closest('[data-arrive-row]').hidden = false;
      }

      renderSale() {
        const row = this.querySelector('[data-sale-row]');
        if (!row || !this.dataset.saleEnd) return;
        // The end date is read as midnight at the end of that day, New York time.
        const [year, month, day] = this.dataset.saleEnd.split('-').map(Number);
        const end = new Date(year, month - 1, day, 23, 59, 59);
        const left = end - zoned(new Date());
        if (!year || left <= 0) {
          row.hidden = true;
          return;
        }
        const days = Math.floor(left / 86400000);
        const hours = Math.floor((left % 86400000) / 3600000);
        const minutes = Math.floor((left % 3600000) / 60000);
        const seconds = Math.floor((left % 60000) / 1000);
        row.querySelector('[data-sale-clock]').textContent =
          (days > 0 ? `${days}d ` : '') + `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
        row.hidden = false;
      }

      // Replaces [time], [day], [from] and [to] in the merchant's text with bold values.
      fill(element, values) {
        const parts = element.dataset.template.split(/(\[(?:time|day|from|to|count)\])/);
        element.replaceChildren(
          ...parts.map((part) => {
            const key = part.slice(1, -1);
            if (part.startsWith('[') && key in values) {
              const strong = document.createElement('strong');
              strong.textContent = values[key];
              return strong;
            }
            return document.createTextNode(part);
          })
        );
      }
    }

    customElements.define('bellace-urgency', BellaceUrgency);
  }
  } catch(e) { console.error(e); }
})();

})();
